var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var OriginRefresh_1;
import './importConfigs/importConfig'; // force import for JsonSchemaV2
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportConfigType } from './importConfigs/importConfig';
import { ImportOperation } from './importTask';
import { originRefreshSchemaValidation } from '../validations.generated';
export const originRefreshSchema = {
    $id: 'urn:wisepipe-common-data:OriginRefresh',
    type: 'object',
    properties: {
        importOperation: {
            type: 'string',
            enum: Object.keys(ImportOperation)
                .map((key) => ImportOperation[key])
                .filter((key) => key !== ImportOperation.New) // Refresh operations shouldn't be New
        },
        importConfig: { $ref: 'urn:wisepipe-common-data:ImportConfig' }
    },
    required: ['importOperation']
};
let OriginRefresh = OriginRefresh_1 = class OriginRefresh {
    constructor(importOperation, importConfig) {
        this.importOperation = importOperation;
        this.importConfig = importConfig;
        // Validate
        if (this.importConfig !== undefined && this.importConfig.importConfigType === ImportConfigType.Global)
            throw new Error('Global data can not be refreshed.');
        JSON.validate(this, OriginRefresh_1);
    }
};
OriginRefresh = OriginRefresh_1 = __decorate([
    JsonSchemaV2(originRefreshSchema, originRefreshSchemaValidation)
], OriginRefresh);
export { OriginRefresh };
//# sourceMappingURL=originRefresh.js.map